var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import ChatComponent from '../chat';
import { updateIsActiveChatPanel } from '../../store/slices/bottomIconsActivitySlice';
import { useAppDispatch } from '../../store';
const RightPanel = ({ currentRoom, isRecorder }) => {
    _react_refresh_temp_3();
    const dispatch = useAppDispatch();
    const closePanel = () => {
        dispatch(updateIsActiveChatPanel(false));
    };
    return (_jsxs("div", { id: "main-right-panel", className: "h-[calc(100%)]", children: [!isRecorder ? (_jsxs("div", { className: "hidden md:inline-block close absolute -left-[14px] z-20 top-1 w-6 h-6 rounded-full border border-solid border-primaryColor dark:border-darkText bg-white dark:bg-darkSecondary cursor-pointer", onClick: closePanel, children: [_jsx("span", { className: "inline-block w-[18px] h-[1px] bg-primaryColor dark:bg-darkText absolute rotate-45 top-[11px] left-[2px]" }), _jsx("span", { className: "inline-block w-[18px] h-[1px] bg-primaryColor dark:bg-darkText absolute -rotate-45 top-[11px] right-[2px]" })] })) : null, _jsx(ChatComponent, { currentRoom: currentRoom, isRecorder: isRecorder })] }));
};
_react_refresh_temp_1 = RightPanel;
$RefreshReg$(_react_refresh_temp_1, "RightPanel");
_react_refresh_temp_3(RightPanel, "BJQ1DUn/XFEl2NsQ3DWyHAXfnkY=", false, () => [useAppDispatch]);
export default _react_refresh_temp_2 = React.memo(RightPanel);
$RefreshReg$(_react_refresh_temp_2, "%default%");
